<template>
  <div class="wiki__container wiki__container--empty" />
</template>
<script>
export default {
  name: "category-sidebar",
};
</script>
<style lang="scss">
.wiki__container--empty {
  min-height: 1px;
}
</style>
